import { motion } from 'framer-motion'
import { hideVisually, transparentize } from 'polished'
import styled, { css } from 'styled-components'

const Navbar = styled.nav`
  ${({ theme }) => css`
    background-color: ${theme.palette.black};
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: ${theme.spacing(1)} ${theme.spacing(2)};

    ${theme.media('xs')} {
      padding: ${theme.spacing(2)} ${theme.spacing(4)};
    }

    ${theme.media('md')} {
      padding: ${theme.spacing(2)} ${theme.spacing(10)};
    }

    & > div {
      display: flex;
      align-items: center;
      gap: ${theme.spacing(2)};
      font-size: 1.4rem;
    }

    > div:first-of-type {
      ${theme.media('xs')} {
        gap: ${theme.spacing(3)};
      }
    }

    > div:last-of-type {
      ${theme.media('xs')} {
        gap: ${theme.spacing(4)};
      }
    }

    img {
      max-height: 2.8rem;
      width: auto;
    }

    h1 {
      font-size: 1.4rem;
      font-weight: 500;
      color: white;
    }
  `}
`

const LinkList = styled.div`
  ${({ theme }) => css`
    ${theme.maxMedia('sm')} {
      ${hideVisually()}
    }

    & > a {
      padding: ${theme.spacing(2)};
      text-decoration: none;
      color: white;

      &:hover {
        opacity: 0.75;
      }
    }
  `}
`

const Hamburger = styled.button.attrs({ type: 'button' })`
  ${({ theme }) => css`
    appearance: none;
    border: none;
    background-color: transparent;
    padding: ${theme.spacing(1)};
    color: #fff;

    ${theme.media('sm')} {
      ${hideVisually()}
    }

    + a {
      line-height: 0;
    }
  `}
`

const Drawer = styled(motion.div)`
  ${({ theme }) => css`
    position: fixed;
    z-index: 999999;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background-color: ${theme.palette.black};
    padding: ${theme.spacing(2)};

    a {
      color: ${theme.palette.white};
      text-decoration-color: ${transparentize(0.5, theme.palette.white)};
      display: block;
      font-size: 3.6rem;
      text-align: center;
      padding: ${theme.spacing(5)};
    }
  `}
`

const CloseButton = styled.button.attrs({ type: 'button' })`
  ${({ theme }) => css`
    position: absolute;
    bottom: ${theme.spacing(2)};
    right: 0;
    left: 0;
    appearance: none;
    border: none;
    background-color: transparent;
    padding: ${theme.spacing(1)};

    svg {
      color: ${theme.palette.white};
    }
  `}
`

const PoweredBy = styled.a`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(2)};
    font-size: 1.1rem;
    color: ${theme.palette.white};

    span {
      font-weight: 300;
      opacity: 0.75;
    }

    ${theme.media('xs')} {
      font-size: 1.3rem;
    }

    img:first-of-type {
      ${theme.maxMedia('xs')} {
        ${hideVisually()}
      }
    }

    img + img {
      ${theme.media('xs')} {
        ${hideVisually()}
      }
    }
  `}
`

export default {
  Navbar,
  LinkList,
  Hamburger,
  Drawer,
  CloseButton,
  PoweredBy,
}
